import React from "react";
import { Box, Typography, CardContent, Divider } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { ReceiptStatsDto } from "../../../shared/dtos/receipt/ReceiptStatsDto";

interface ReceiptWidgetProps {
  data: ReceiptStatsDto;
}

const ReceiptWidget: React.FC<ReceiptWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("RECEIPT");
  const Icon = meta.icon;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Revenue Today
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "success.main" }}
          >
            {formatCurrency(data.totalRevenueToday)}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Receipts Issued Today
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            {data.totalReceiptsToday}
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default ReceiptWidget;
